import React from 'react'
import { RiWifiOffLine } from "react-icons/ri";
import { useState, useEffect } from 'react';
import Toggle from "../../components/common/toggle";

const OfflineSettings = ({ data, setData }) => {
  const [enableOfflineMode, setEnableOfflineMode] = useState(true);
  const [autoSyncIntervalMinutes, setAutoSyncIntervalMinutes] = useState("");
  const [categories, setCategories] = useState(true);
  const [products, setProducts] = useState(true);
  const [media, setMedia] = useState(true);
  const [industry, setIndustry] = useState(true);

  // Populate form fields when data is received from API
  useEffect(() => {
    if (data && data.offlineSettings && data.offlineSettings.autoSyncIntervalMinutes !== undefined) {
      setEnableOfflineMode(data.offlineSettings?.enableOfflineMode ?? true);
      setAutoSyncIntervalMinutes(data.offlineSettings?.autoSyncIntervalMinutes?.toString() || "");
      setCategories(data.offlineSettings?.allowedContentTypes?.categories ?? true);
      setProducts(data.offlineSettings?.allowedContentTypes?.products ?? true);
      setMedia(data.offlineSettings?.allowedContentTypes?.media ?? true);
      setIndustry(data.offlineSettings?.allowedContentTypes?.industry ?? true);
    }
  }, [data?.offlineSettings?.enableOfflineMode, data?.offlineSettings?.autoSyncIntervalMinutes, data?.offlineSettings?.allowedContentTypes?.categories, data?.offlineSettings?.allowedContentTypes?.products, data?.offlineSettings?.allowedContentTypes?.media, data?.offlineSettings?.allowedContentTypes?.industry]);

  useEffect(() => {
    if (setData && enableOfflineMode !== undefined) {
      setData(prevData => ({
        ...prevData,
        offlineSettings: {
          ...prevData.offlineSettings,
          enableOfflineMode,
          autoSyncIntervalMinutes: Number(autoSyncIntervalMinutes) || 0,
          allowedContentTypes: {
            categories,
            products,
            media,
            industry,
          }
        }
      }));
    }
  }, [enableOfflineMode, autoSyncIntervalMinutes, categories, products, media, industry]);

  return (
    <>
    <div className="settingsCard">
            <h4>
              <RiWifiOffLine /> Offline Settings
            </h4>
            <p>
              Manage offline mode and content syncing
            </p>
             <div className="body">
            <form action="post">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="label">
                  <label htmlFor="">Enable Offline Mode</label>
                  <p>Allow users to access content offline</p>
                </div>
                <Toggle
                  onChange={(newChecked) => setEnableOfflineMode(newChecked)}
                  checked={enableOfflineMode}
                />
              </div>
              <div
                  className="form-header"
                  style={{ display: "flex", gap: "20px", alignItems: "center" }}
                >
                  <div
                    className="text-inputs"
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                    }}
                  >
                    <div style={{ marginTop: "30px",marginBottom: "10px" }}>
                      <label htmlFor="autoSyncInterval">Auto Sync Interval (Minutes)</label>
                      <input
                        type="number"
                        id="autoSyncInterval"
                        name="autoSyncIntervalMinutes"
                        placeholder="..."
                        value={autoSyncIntervalMinutes}
                        onChange={(e) => setAutoSyncIntervalMinutes(e.target.value)}
                        style={{ marginTop: "20px" }}
                      />
                    </div>
                  </div>
                </div>
                <p>How often to sync content when online</p>


<div
                  className="form-header"
                  style={{ display: "flex", gap: "20px" }}
                >
                    <div
                    className="text-inputs"
                    style={{
                      flex: 1,
                      display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                    }}
                  >
                    <div style={{ marginTop: "30px",marginBottom: "10px"}}>
                        <label htmlFor="allowedContentTypes">Allowed Content Types</label><br />
                        <input 
                            type="checkbox"
                            id="categories"
                            name="categories"
                            checked={categories}
                            onChange={(e) => setCategories(e.target.checked)}
                            style={{ marginTop: "20px", width: "auto", height: "fit-content" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Categories</span>
                        <br />
                        <input
                            type="checkbox"
                            id="products"
                            name="products"
                            checked={products}
                            onChange={(e) => setProducts(e.target.checked)}
                            style={{ marginTop: "20px", width: "auto", height: "fit-content" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Products</span>
                        <br />
                        <input
                            type="checkbox"
                            id="media"
                            name="media"
                            checked={media}
                            onChange={(e) => setMedia(e.target.checked)}
                            style={{ marginTop: "20px", width: "auto", height: "fit-content" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Media</span>
                        <br />
                        <input
                            type="checkbox"
                            id="industry"
                            name="industry"
                            checked={industry}
                            onChange={(e) => setIndustry(e.target.checked)}
                            style={{ marginTop: "20px", width: "auto", height: "fit-content" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Industry</span>

                    </div>
                  </div>
                </div>
            </form>
          </div>
    </div>
    </>
  )
}

export default OfflineSettings